const sleep = (delay = 1000) => {
  return new Promise(resolve => {
    window.setTimeout(resolve, delay)
  })
}

export default sleep
